// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

function ListView({
  antennaList, receiverList, frequencyStandardSensorList, radomeList,
}) {
  return (
    <div className="tab-pane fade" id="listView-tab-pane" role="tabpanel" aria-labelledby="listView-tab" tabIndex="0">
      <div className="instrument--list">
        <div className="instrument--list__container">
          <h1>Antennas</h1>
          {antennaList.map((elem) => (
            <div
              key={elem.currentDateId}
            >
              <p key={elem.antennaId}><span className="name">Antenna type: </span>{elem.antenna}</p>
              <p key={elem.antenna_serial_number_id}><span className="name">Serial number: </span>{elem.antenna_serial_number}</p>
              <p key={elem.antenna_reference_point_id}><span className="name">Antenna Reference Point: </span>{elem.antenna_reference_point}</p>
              <p key={elem.marker_arp_up_ecc_id}><span className="name">Marker ARP up ecc: </span>{elem.marker_arp_up_ecc}</p>
              <p key={elem.marker_arp_north_ecc_id}><span className="name">Marker ARP north ecc: </span>{elem.marker_arp_north_ecc}</p>
              <p key={elem.marker_arp_east_ecc_id}><span className="name">Marker ARP east ecc: </span>{elem.marker_arp_east_ecc}</p>
              <p key={elem.alignment_from_true_n_id}><span className="name">Alignment from true n: </span>{elem.alignment_from_true_n}</p>
              <p key={elem.antenna_cable_type_id}><span className="name">Antenna cable type: </span>{elem.antenna_cable_type.toString()}</p>
              <p key={elem.antenna_cable_length_id}><span className="name">Antenna cable length: </span>{elem.antenna_cable_length}</p>
              <p key={elem.datefromId}><span className="name">Date from: </span>{elem.datefrom}</p>
              <p key={elem.datetoId}><span className="name">Date to: </span>{elem.currentDate === elem.dateto ? '' : elem.dateto}</p>
              <p key={elem.commentId}><span className="name">Comment: </span>{elem.comment}</p>
            </div>
          ))}
        </div>
        <div className="instrument--list__container">
          <h1>Receivers</h1>
          {receiverList.map((elem) => (
            <div
              key={elem.currentDateId}
            >
              <p key={elem.receiverId}><span className="name">Receiver type: </span>{elem.receiver}</p>
              <p key={elem.receiver_serial_number_id}><span className="name">Serial number: </span>{elem.receiver_serial_number}</p>
              <p key={elem.firmwareId}><span className="name">Firmware version: </span>{elem.firmware}</p>
              <p key={elem.receiver_elevation_cutoff_setting_id}><span className="name">Elevation cutoff setting: </span>{elem.receiver_elevation_cutoff_setting}</p>
              <p key={elem.receiver_temperature_stabilization_id}><span className="name">Temperature stabilization: </span>{elem.receiver_temperature_stabilization}</p>
              {(frequencyStandardSensorList.length === 0) && <p key={elem.receiver_input_frequency_id}><span className="name">Input frequency: </span>{elem.receiver_input_frequency}</p>}
              {(frequencyStandardSensorList.length !== 0)
              && frequencyStandardSensorList.map((elem2) => (
                <span key={elem2.datefromId}>
                  {(elem2.datefrom <= elem.datefrom && elem2.dateto >= elem.dateto) && <p key={elem2.sensor_input_frequency_id}><span className="name">Input frequency: </span>{elem2.sensor_input_frequency}</p>}
                </span>
              ))}
              <p key={elem.receiver_data_sampling_interval_id}><span className="name">Data sampling interval: </span>{elem.receiver_data_sampling_interval}</p>
              <p key={elem.satellites_system_id}><span className="name">Satellite systems: </span>{elem.satellites_system}</p>
              <p key={elem.datefromId}><span className="name">Date from: </span>{elem.datefrom}</p>
              <p key={elem.datetoId}><span className="name">Date to: </span>{elem.currentDate === elem.dateto ? '' : elem.dateto}</p>
              <p key={elem.commentId}><span className="name">Comment: </span>{elem.comment}</p>
            </div>
          ))}
        </div>
        <div className="instrument--list__container">
          <h1>Radomes</h1>
          {radomeList.map((elem) => (
            <div key={elem.currentDateId}>
              <p key={elem.radomeId}><span className="name">Radome type: </span>{elem.radome}</p>
              <p key={elem.descriptionId}><span className="name">Description: </span>{elem.description}</p>
              <p key={elem.datefromId}><span className="name">Date from: </span>{elem.datefrom}</p>
              <p key={elem.datetoId}><span className="name">Date to: </span>{elem.currentDate === elem.dateto ? '' : elem.dateto}</p>
              <p key={elem.commentId}><span className="name">Comment: </span>{elem.comment}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

ListView.propTypes = {
  antennaList: PropTypes.arrayOf(
    PropTypes.shape({
      currentDate: PropTypes.string.isRequired,
      currentDateId: PropTypes.string.isRequired,
      datefrom: PropTypes.string.isRequired,
      datefromId: PropTypes.string.isRequired,
      dateto: PropTypes.string.isRequired,
      datetoId: PropTypes.string.isRequired,
      antenna: PropTypes.string.isRequired,
      antennaId: PropTypes.string.isRequired,
      antenna_serial_number: PropTypes.string.isRequired,
      antenna_serial_number_id: PropTypes.string.isRequired,
      antenna_reference_point: PropTypes.string.isRequired,
      antenna_reference_point_id: PropTypes.string.isRequired,
      marker_arp_up_ecc: PropTypes.number.isRequired,
      marker_arp_up_ecc_id: PropTypes.string.isRequired,
      marker_arp_north_ecc: PropTypes.number.isRequired,
      marker_arp_north_ecc_id: PropTypes.string.isRequired,
      marker_arp_east_ecc: PropTypes.number.isRequired,
      marker_arp_east_ecc_id: PropTypes.string.isRequired,
      alignment_from_true_n: PropTypes.number.isRequired,
      alignment_from_true_n_id: PropTypes.string.isRequired,
      antenna_cable_type: PropTypes.string.isRequired,
      antenna_cable_type_id: PropTypes.string.isRequired,
      antenna_cable_length: PropTypes.number.isRequired,
      antenna_cable_length_id: PropTypes.string.isRequired,
      comment: PropTypes.string,
      comment_id: PropTypes.string,
    }).isRequired,
  ).isRequired,
  receiverList: PropTypes.arrayOf(
    PropTypes.shape({
      currentDate: PropTypes.string.isRequired,
      currentDateId: PropTypes.string.isRequired,
      datefrom: PropTypes.string.isRequired,
      datefromId: PropTypes.string.isRequired,
      dateto: PropTypes.string.isRequired,
      datetoId: PropTypes.string.isRequired,
      receiver: PropTypes.string.isRequired,
      receiverId: PropTypes.string.isRequired,
      receiver_serial_number: PropTypes.string.isRequired,
      receiver_serial_number_id: PropTypes.string.isRequired,
      firmware: PropTypes.string.isRequired,
      firmwareId: PropTypes.string.isRequired,
      satellites_system: PropTypes.string.isRequired,
      satellites_system_id: PropTypes.string.isRequired,
      receiver_elevation_cutoff_setting: PropTypes.number.isRequired,
      receiver_elevation_cutoff_setting_id: PropTypes.string.isRequired,
      receiver_temperature_stabilization: PropTypes.number.isRequired,
      receiver_temperature_stabilization_id: PropTypes.string.isRequired,
      receiver_input_frequency: PropTypes.string.isRequired,
      receiver_input_frequency_id: PropTypes.string.isRequired,
      receiver_data_sampling_interval: PropTypes.string,
      receiver_data_sampling_interval_id: PropTypes.string.isRequired,
      comment: PropTypes.string,
      commentId: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  frequencyStandardSensorList: PropTypes.arrayOf(
    PropTypes.shape({}).isRequired,
  ).isRequired,
  radomeList: PropTypes.arrayOf(
    PropTypes.shape({
      currentDate: PropTypes.string.isRequired,
      currentDateId: PropTypes.string.isRequired,
      datefrom: PropTypes.string.isRequired,
      datefromId: PropTypes.string.isRequired,
      dateto: PropTypes.string.isRequired,
      dateotId: PropTypes.string.isRequired,
      radome: PropTypes.string.isRequired,
      radomeId: PropTypes.string.isRequired,
      description: PropTypes.string,
      descriptionId: PropTypes.string.isRequired,
      comment: PropTypes.string,
      commentId: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
};

export default ListView;
